export default __webpack_public_path__ + "static/media/fourteen.095b7f3b.jpg";